export default __webpack_public_path__ + "static/media/Icon.c2838a42.png";